export default () => {
  const gallery = document.querySelector('.gallery-block');
  const image = gallery.querySelector('.gallery-img-two-vert');
  const imageHeight = image.offsetHeight;
  const galleryHeight = imageHeight * 2;

  gallery.addEventListener('click', () => {
    gallery.style.height = '100%';
  });

  if (window.innerWidth <= 1199) {
    updateGalleryHeight();
  }

  window.addEventListener('resize', updateGalleryHeight);

  function updateGalleryHeight() {
    gallery.style.setProperty('--gallery-block-height', galleryHeight);
  }
};
